import { useSinglePageGrid } from "2g-grid";

import { DATA } from "b2b/api/paths";
import { ZadostiRowDetail } from "b2b/components/zadosti-row-detail/ZadostiRowDetail";

import useMessages from "./i18n/useMessages";
import useColumns from "./useColumns";
import resolveRequest from "./resolveRequest";
import ZadostiHistorieFilterContent from "./ZadostiHistorieFilterContent";

export default function useZadostiHistorieGrid() {
  const columns = useColumns();
  const messages = useMessages();
  return useSinglePageGrid({
    moduleKey: "zadostiHistorieGrid",
    filter: {
      asSlideFilter: true,
      content: ZadostiHistorieFilterContent,
      title: messages.pageHeadingFilter()
    },
    result: {
      collapsable: false,
      title: messages.pageHeading(),
      url: DATA.zadostiSeznamHistorie(),
      resolveRequest,
      method: "post",
      columns,
      showFilterDescription: true,
      sortable: true,
      loadOnInit: true,
      rowDetail: ZadostiRowDetail
    }
  });
}
